import * as RadixTabs from "@radix-ui/react-tabs";
import cx from "classnames";
import { type ForwardRefRenderFunction, type RefAttributes, forwardRef } from "react";

import styles from "./_.module.css";

const TabsTrigger: ForwardRefRenderFunction<
	HTMLButtonElement,
	RadixTabs.TabsTriggerProps &
		RefAttributes<HTMLButtonElement> & {
			isPinned?: boolean;
			isFlexTab?: boolean;
		}
> = ({ className, isPinned, isFlexTab, children, ...props }, ref) => {
	return (
		<RadixTabs.Trigger
			ref={ref}
			className={cx(
				styles["tab"],
				"group",

				"relative",
				"self-end",

				"h-8",
				"p-2",
				"-ml-px",
				"max-w-[12rem]",

				"border-t",
				"border-r",
				"border-l",
				"rounded-tl",

				"rounded-tr",

				"text-left",
				"text-sm",

				"data-[state=active]:bg-primary",
				"data-[state=active]:text-primary",
				"data-[state=inactive]:bg-secondary",
				"data-[state=inactive]:hover:bg-primary",
				"data-[state=inactive]:text-secondary",

				"hover:cursor-pointer",

				"transition-colors",
				{
					"italic": isFlexTab,
					"not-italic": !isFlexTab,
					[styles["pinned"]]: isPinned,
				},
				className
			)}
			{...props}
		>
			<div className="line-clamp-1 text-ellipsis">{children}</div>
		</RadixTabs.Trigger>
	);
};

const TabsList: ForwardRefRenderFunction<
	HTMLDivElement,
	RadixTabs.TabsListProps & React.RefAttributes<HTMLDivElement>
> = ({ className, ...props }, ref) => {
	return (
		<div className={cx("flex", "grow", "relative", "overflow-hidden", styles["tab-container"])}>
			<RadixTabs.List
				ref={ref}
				className={cx(
					"flex",
					"grow",
					"overflow-x-auto",
					"pl-2",
					"pr-4",
					"pt-1.5",
					"relative",
					styles["tab-container-scroller"],
					className
				)}
				{...props}
			/>
		</div>
	);
};

const Root: ForwardRefRenderFunction<
	HTMLDivElement,
	RadixTabs.TabsProps & React.RefAttributes<HTMLDivElement>
> = ({ className, ...props }, ref) => {
	return <RadixTabs.Root ref={ref} className={cx("flex", "grow", className)} {...props} />;
};

export const TabsComponent = {
	Root: forwardRef(Root),
	List: forwardRef(TabsList),
	Trigger: forwardRef(TabsTrigger),
	Content: RadixTabs.Content,
};
